import { makeStyles } from "@material-ui/core/styles";

export function useUsersStyles() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    header: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "1.3rem",
    },
    title: {
      fontWeight: 400,
      fontSize: "1.5rem",
    },
    textField: {
      margin: 16,
      width: "40%",
    },
    tableContainer: {
      maxHeight: 600,
      minHeight: 400,
    },
    tableCell: {
      padding: "18px 16px",
    },
    tableTH: {
      color: "#FFF",
      backgroundColor: "#004B97",
      padding: "10px 16px",
    },
    paginationContainer: {
      padding: 16,
      display: "flex",
      justifyContent: "center",
      "& button": {
        borderRadius: 20,
      },
    },
    chipsBox: {
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(1),
    },
    ActionsMenuItem: {
      gap: 10,
      display: "flex",
      fontWeight: 500,
      color: "#000",
      "&:hover": {
        textDecoration: "none",
      },
    },
    addButton: {
      color: '#FFF',
      backgroundColor: '#004B97',
      fontSize: '0.95rem',
      padding: '0.5rem 1rem',
      '&:hover': {
          backgroundColor: '#003366',
      },
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
